import {ChangeDetectorRef, Component, computed, inject, Input, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {RestClient} from '../../../../../Api/DcoApi/Client/RestClient';
import {hub, NotificationService} from "../../../../../Services/NotificationService";
import {Spinner} from '../../../../../Componente/Spinner';
import {PGFilterService} from '../../../../Services/PGFilterService';
import {asyncScheduler, Subject, throttleTime} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-file-upload-export',
  imports: [
    CommonModule,
    Spinner,
    FormsModule
  ],
  standalone: true,
  templateUrl: './file-upload-export.html',
  styleUrl: './file-upload-export.css',
})
export class FileUploadExport {
  @Input() Partner: number = 0;
  @Input() Lauf: number = 0;

  modal = inject(NgbActiveModal);
  ApiClient:RestClient = new RestClient();

  private NotificationService = inject(NotificationService);
  hub:hub | null = null

  IsCalculating = signal<boolean>(true);
  CanClose = signal<boolean>(false);
  Success = signal<boolean>(false);
  ShowErrorInfo = signal<boolean>(false);

  FileGenerating = signal<boolean>(true);
  FileGenerated = signal<boolean>(false);
  StartDownloadFile = signal<boolean>(false);

  AnzahlEintraege = signal<number>(0);
  AktuellerEintrag = signal<number>(0);

  CalculatePercentage = computed(() => this.AktuellerEintrag() / this.AnzahlEintraege() * 100);

  private fileUpdate$ = new Subject<ICopyDataFileEvent>();


  constructor() {
    this.fileUpdate$.pipe(
      throttleTime(500, asyncScheduler, { leading: true, trailing: true })
    ).subscribe(file => {
      this.FileGenerated.set(true);
      this.FileGenerating.set(false);
      this.AnzahlEintraege.set(file.Sum);
      this.AktuellerEintrag.set(file.File);
    });
  }

  updateUI(info: any)
  {
    switch(info.eventType)
    {
      case 'GeneratingDataFile':
        this.FileGenerating.update(o => true);
        break;
      case 'CopyDataFile':
        var file = JSON.parse(info.eventData) as ICopyDataFileEvent;
        try
        {
          this.fileUpdate$.next(file);
        }
        catch (e)
        {
          debugger;
          console.log(e);
        }
        break;
      case 'Error':
        this.ShowErrorInfo.set(true);
        break;
      case 'StartDownload':
        this.StartDownloadFile.update(o => true);
        break;
      case 'Finish':
        this.IsCalculating.set(false);
        this.CanClose.set(true);
        this.Success.set(true);
        this.hub?.stop()
        break;
      case 'Faild':
        this.ShowErrorInfo.set(true);
        this.IsCalculating.set(false);
        this.CanClose.set(true);
        this.hub?.stop()
        break;
    }

  }

  async StartUpload()
  {
    this.hub = await this.NotificationService.RunFunction<any>(`/AbrechnungData/Upload/${this.Partner}/${this.Lauf}/`,null, i => this.updateUI(i));
  }

  async StartDownload()
  {
    await this.NotificationService.RunDownload(`/AbrechnungData/Export/${this.Partner}/${this.Lauf}/`, `Abrechnung_${this.Lauf}.zip`, i => this.updateUI(i));
    this.IsCalculating.set(false);
    this.CanClose.set(true);
    this.Success.set(true);
  }
}


interface ICopyDataFileEvent
{
  File:number;
  Sum:number;
}
